import {useState} from 'react';
import {NavLink, Route, Routes} from 'react-router-dom';
import logoFull from './assets/logo-full.png';
import logoMark from './assets/logo-mark.png';
import Pipeline from './pages/Pipeline';
import Overview from './pages/Overview';
import Candidates from './pages/Candidates';
import Jobs from './pages/Jobs';
import Diagnoses from './pages/Diagnoses';
import Showcase from './pages/Showcase';

const LINKS = [
  {to: '/', end: true, full: '筛选流水线', short: '流水'},
  {to: '/showcase', full: '星环实验场', short: '星环'},
  {to: '/overview', full: '统计 Overview', short: '统计'},
  {to: '/candidates', full: 'Candidates', short: '候选'},
  {to: '/jobs', full: 'Jobs', short: '任务'},
  {to: '/diagnoses', full: 'Diagnoses', short: '诊断'},
];

export default function App() {
  // 全局左侧导航可折叠
  const [navOpen, setNavOpen] = useState(true);
  return (
    <div className="layout">
      <nav className={`sidebar${navOpen ? '' : ' collapsed'}`}>
        <button className="nav-toggle"
                onClick={() => setNavOpen(o => !o)}
                title={navOpen ? '收起导航栏' : '展开导航栏'}>
          {navOpen ? '‹' : '›'}
        </button>
        <div className="logo" title="KAIROS MATERIALS · 开物纪">
          {navOpen
            ? <img src={logoFull} alt="KAIROS MATERIALS 开物纪"
                   style={{height: 48, display: 'block'}} />
            : <img src={logoMark} alt="KAIROS"
                   style={{height: 28, display: 'block', margin: '0 auto'}} />}
        </div>
        {LINKS.map(l => (
          <NavLink key={l.to} to={l.to} end={l.end}
                   title={navOpen ? undefined : l.full}>
            <span className="nav-full">{l.full}</span>
            {!navOpen && <span className="nav-short">{l.short}</span>}
          </NavLink>
        ))}
      </nav>
      <main className="main">
        <Routes>
          <Route path="/" element={<Pipeline />} />
          <Route path="/showcase" element={<Showcase />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/candidates" element={<Candidates />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/diagnoses" element={<Diagnoses />} />
        </Routes>
      </main>
    </div>
  );
}
